module.exports = __webpack_public_path__ + "img/2.3ff3d1c.webp";